import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Loader from '../../components/Loader';
import Hero from '../../components/Hero';
import Footer from '../../components/Footer';
import './index.css';

export default function Iglesias() {
    const [churches, setChurches] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const apiUrl = '/api/churches';
        const fetchData = async () => {
            try {
                const response = await fetch(apiUrl);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const jsonData = await response.json();
                setChurches(jsonData);
                setLoading(false);
            } catch (e) {
                setLoading(false);
            }
        };
        fetchData();
    }, []);
    if(!churches || loading){
        return <Loader topAvance={150} />;
    }
    return (
        <main className="g-main churches">
            <Hero title="Iglesias PFB" description="Listado de Iglesias y Locales en el territorio nacional" size='s' />
            <section className="content-main">
                <table className="table-churches">
                    <thead>
                        <tr>
                            <th className="th-churches">Ciudad</th>
                            <th className="th-churches">Iglesia</th>
                        </tr>
                    </thead>
                    <tbody>
                        {churches.map((church) => (
                            <tr key={church.uuid_church} className="tr-churches">
                                <td className="td-churches">
                                    <Link to={`/iglesia/${church.uuid_church}`} className="g-link">
                                        {church.name}
                                    </Link>
                                </td>
                                <td className="td-churches">{church.city}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </section>
            <Footer />
        </main>
    );
}